import React, { useEffect, useState } from "react";
import { ListNav, List, Sidebar } from "./index";
import dummy from "../data";
import { Container, ListFilter, Pagination } from "../../../components";
import { SystemProvider } from "../../../features/system/provider";
import { useHistory, useLocation } from "react-router-dom";
import qs from 'query-string'

const DEFAULT_CURRENT_PAGE = 1
const DEFAULT_ITEMS_PER_PAGE = 2

const MainContent = ({ query, data, sortOptions, handleSort, countData }) => {
  const location = useLocation()
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(DEFAULT_CURRENT_PAGE)
  const [pageIndexes, setPageIndexes] = useState([0, DEFAULT_ITEMS_PER_PAGE])

  const handlePaginationChange = (newPage) => {
    setCurrentPage(newPage)

    const startIndex = (newPage-1)*DEFAULT_ITEMS_PER_PAGE
    const endIndex = startIndex + DEFAULT_ITEMS_PER_PAGE
    setPageIndexes([startIndex, endIndex])
  }

  const pathname = location.pathname.split('/search-results')[1]

  useEffect(() => {
    const limit = DEFAULT_ITEMS_PER_PAGE
    const offset = (currentPage - 1)*DEFAULT_ITEMS_PER_PAGE

    const newQuery = {
      ...query,
      limit,
      offset
    }

    const searchString = qs.stringify(newQuery)
    const currentPath = location.pathname

    history.replace({
      pathname: currentPath,
      search: '?'+searchString
    })

    // eslint-disable-next-line
  }, [currentPage])

  return (
    <Container className="hidden lg:block">
      <div className="flex flex-wrap -mx-4 py-16">
        <aside className="w-3/12 px-4 hidden lg:block">
          <Sidebar />
        </aside>
        <main className="w-full lg:w-9/12 px-4">
          <ListNav rawData={dummy} data={data ? data : []} countData={countData}/>
          <ListFilter
            totalData={countData[pathname]}
            sortOptions={sortOptions}
            onSort={handleSort}
            query={query}
            pageIndexes={pageIndexes}
          />
          <SystemProvider>
            {/* Note: <List /> harus ke-render, karena ada contoh UI jika datanya kosong. (/resources) */}
            <List query={query} data={data} />
          </SystemProvider>
          <Pagination
            totalItems={countData[pathname]}
            defaultCurrentPage={DEFAULT_CURRENT_PAGE}
            itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
            onChange={handlePaginationChange}
          />
        </main>
      </div>
    </Container>
  );
};

export { MainContent };
